export default __webpack_public_path__ + "static/media/title.6a606394.svg";